import React, { useEffect, useState } from "react";
import { Content, Row, Col, Box, Button, Inputs } from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import SelectInput from "../utils/SelectInput";
import "react-phone-input-2/lib/style.css";
import TimeInput from "react-time-picker-input";
import Multiselect from "multiselect-react-dropdown";
import ImagenesLista from "../imageUploadV3/ImagenesLista";
import { HexColorPicker } from "react-colorful";
import config from "../config";
import { logger } from "../utils/utils";
import queryString from "query-string";
import Loader from "../utils/Loader";
import ReferenciaObligatorios from "../utils/etiquetaObligatorio/ReferenciaObligatorios";
import Etiqueta from "../utils/etiquetaObligatorio/Etiqueta";
import PYG from "../utils/PYG";

const { Text } = Inputs;

const estadoOptions = () => [
  { value: "ACTIVO", label: "ACTIVO" },
  { value: "INACTIVO", label: "INACTIVO" },
];

function EditServicioHijo({ history, match }) {
  const dispatch = useDispatch();

  const modelEditServicio = useSelector((state) => state.editServicio);
  const modelServicioById = useSelector((state) => state.servicioById);
  const modelProfesionales = useSelector(
    (state) => state.profesionalesForSelect
  );
  const modelServiciosPadre = useSelector(
    (state) => state.serviciosPadreAsOptions
  );
  const [serviciosPadreOptions, setServiciosPadreOptions] = useState([]);
  const [profesionalesOptions, setProfesionalesOptions] = useState([]);
  const [profesionales, setProfesionales] = useState([]);
  const [allSelected, setAllSelected] = useState([]);
  const [horarioTomarReserva, setHorarioTomarReserva] = useState("22:00");
  const [nombre, setNombre] = useState(null);
  const [descripcion, setDescripcion] = useState(null);
  const [precio, setPrecio] = useState("");
  const [formattedPrecio, setFormattedPrecio] = useState("");
  const [duracion, setDuracion] = useState(null);
  const [estado, setEstado] = useState("ACTIVO");
  const [localId, setLocalId] = useState(match.params.localId);
  const [servicioPadre, setServicioPadre] = useState(null);
  const [direccionNecesaria, setDireccionNecesaria] = useState(false);
  const [maxPersonas, setMaxPersonas] = useState(1);
  const [servicioId, setServicioId] = useState(match.params.id);
  const [imagenes, setImagenes] = useState();
  const [token, setToken] = useState(() => localStorage.getItem("token"));
  const [imagenesListaLoading, setImagenesListaLoading] = useState(false);

  const [color, setColor] = useState("#aabbcc");
  const [mostrarColorPicker, setMostrarColorPicker] = useState(false);

  const [colorActual, setColorActual] = useState(null);
  const [horarioMaximoReservar, setHorarioMaximoReservar] = useState("00:00");
  const [tiempoEntreTurnos, setTiempoEntreTurnos] = useState("");

  useEffect(() => {
    const data = modelProfesionales?.data?.data?.data;
    const error = modelProfesionales?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckProfesionalesForSelect.actions.clear());
    }
    if (data) {
      const all = {
        value: "ALL",
        label: "Seleccionar todos",
      };
      const allValues = data.map((row) => row.value);
      setAllSelected(allValues);
      // data.unshift(all);
      setProfesionalesOptions(data);
      dispatch(controller.servicioByIdThunk(match.params.id));
      dispatch(controller.duckProfesionalesForSelect.actions.clear());
    }
  }, [modelProfesionales]);

  const modelEliminacionImgServicio = useSelector((state) => {
    return state.eliminacionImgServicio;
  });

  useEffect(() => {
    const data = modelServiciosPadre?.data?.data?.data;
    const error = modelServiciosPadre?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckServiciosPadreAsOptions.actions.clear());
    }
    if (data) {
      setServiciosPadreOptions(data);

      dispatch(controller.duckServiciosPadreAsOptions.actions.clear());
    }
  }, [modelServiciosPadre]);

  useEffect(() => {
    if (match.params.categoriaId === "60f806a5e3e9af972fe85c7a") {
      dispatch(
        controller.profesionalesForSelectThunk(match.params.localId, true)
      );
    } else {
      dispatch(controller.profesionalesForSelectThunk(match.params.localId));
    }
    dispatch(controller.serviciosPadreAsOptionsThunk(match.params.localId));
  }, []);

  useEffect(() => {
    const data = modelEditServicio?.data?.data;
    const error = modelEditServicio?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckEditServicio.actions.clear());
    }
    if (data) {
      history.push(
        `/serviciosHijosList/${match.params.localId}/${servicioPadre}/${match.params.categoriaId}`
      );
      dispatch(controller.duckEditServicio.actions.clear());
    }
  }, [modelEditServicio]);

  useEffect(() => {
    const data = modelServicioById?.data?.data?.data;
    const error = modelServicioById?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckServiciosById.actions.clear());
    }
    if (data) {
      setNombre(data.nombre);
      setDescripcion(data.descripcion);
      if (data.precio) {
        setPrecio(String(data.precio));
      }

      setDuracion(data.duracion);
      setMaxPersonas(data.maxPersonas);
      setServicioPadre(data.servicioPadre);
      setHorarioTomarReserva(data.horarioTomarReserva);
      if (data.horarioMaximoReservar) {
        setHorarioMaximoReservar(data.horarioMaximoReservar);
      }

      if (data.tiempoEntreTurnos) {
        setTiempoEntreTurnos(data.tiempoEntreTurnos);
      }

      setImagenes(data.imagenes);
      const optionsAux = [];
      data.profesionales.forEach((row, index) => {
        const optionsSelected = profesionalesOptions.filter(
          (item) => item.value === row
        );
        if (optionsSelected.length > 0) {
          optionsAux.push(optionsSelected[0]);
        }
      });

      setProfesionales(optionsAux);
      setImagenesListaLoading(false);
      data.color && setColorActual(data.color);
      dispatch(controller.duckServiciosById.actions.clear());
    }
  }, [modelServicioById]);

  useEffect(() => {
    // TODO usar "selectors" para data y error

    const data = modelEliminacionImgServicio?.data?.data?.data;
    const error = modelEliminacionImgServicio?.error;
    const errorMessage =
      modelEliminacionImgServicio?.error?.response?.data?.mensaje;

    if (error) {
      if (errorMessage) {
        alert(errorMessage);
      }
      setImagenesListaLoading(false);
      dispatch(controller.duckEliminarImgServicio.actions.clear());
    }

    if (data) {
      if (match.params.categoriaId === "60f806a5e3e9af972fe85c7a") {
        dispatch(
          controller.profesionalesForSelectThunk(match.params.localId, true)
        );
      } else {
        dispatch(controller.profesionalesForSelectThunk(match.params.localId));
      }
      dispatch(controller.serviciosPadreAsOptionsThunk(match.params.localId));
    }
  }, [modelEliminacionImgServicio, dispatch]);

  function submit() {
    if (
      match.params.categoriaId !== "60f806a5e3e9af972fe85c7a" &&
      (!nombre ||
        !descripcion ||
        profesionales.length === 0 ||
        !Number(precio) < 0 ||
        !duracion ||
        duracion < 1 ||
        !estado ||
        !localId ||
        // !servicioPadre ||
        !maxPersonas)
    ) {
      alert("Por favor complete todos los campos");
      return;
    }

    if (
      match.params.categoriaId === "60f806a5e3e9af972fe85c7a" &&
      (!nombre ||
        !descripcion ||
        !profesionales.length === 0 ||
        !estado ||
        !localId)
    ) {
      alert("Por favor complete todos los campos");
      return;
    }

    const arrayProfesionalesValue = [];
    profesionales.forEach((row, index) => {
      arrayProfesionalesValue.push(row.value);
    });

    let data = {
      _id: match.params.id,
      nombre,
      horarioTomarReserva,
      descripcion,
      precio,
      duracion,
      estado,
      localId,
      servicioPadre,
      direccionNecesaria,
      maxPersonas,
      profesionales: arrayProfesionalesValue,
      color: mostrarColorPicker ? color : colorActual,
      horarioMaximoReservar,
      tiempoEntreTurnos,
    };
    dispatch(controller.editServicioThunk(data));
  }

  const navigateToSubirImagenes = () => {
    logger.debug("navigateToSubirImagenes");

    const baseUrl = config.api.baseUrl;
    const key = config.api.key;

    const concepto = "servicio";
    const conceptoId = servicioId;

    logger.debug({ concepto });
    logger.debug({ config });
    logger.debug({
      imgRestrictionsByConcepto: config.imgRestrictionsByConcepto[concepto],
    });

    const uploadConfigVariant = "upload";
    const cropConfigVariant = "crop";

    const uploadUrl = `${baseUrl}/agregarImagen/${concepto}/${conceptoId}/?userToken=${token}&esTemporal=true&configVariant=${uploadConfigVariant}`;
    const uploadHeaders = {
      "x-access-token": key,
    };

    const cropUploadUrl = `${baseUrl}/agregarImagen/${concepto}/${conceptoId}/?userToken=${token}&esTemporal=false&configVariant=${cropConfigVariant}`;
    const cropConfig =
      config.imgRestrictionsByConcepto[concepto][cropConfigVariant];

    const nextStepUrl = `/cortarImagenes`;
    const lastStepUrl = `/editServicio/${localId}/${servicioId}`;

    const params = queryString.stringify({
      conceptoId,
      concepto,
      uploadUrl,
      rawUploadHeaders: JSON.stringify(uploadHeaders),
      nextStepUrl,
      pageTitle: "Subida de imágenes",
      pageSubtitle: "Paso 1 : Subida",
      nextButtonText: "Siguiente",
      cropConfig: JSON.stringify(cropConfig),
      cropUploadUrl,
      saveInConceptUrl: `${baseUrl}/agregarImagenAServicioV3`,
      lastStepUrl,
      ...config.imgRestrictionsByConcepto[concepto][uploadConfigVariant],
    });

    logger.debug("EditServicioHijo.paramsBeforeNavigate");
    logger.debug(params);

    history.push(`/subirImagenes?${params}`);
  };

  const doEliminarImagen = (imagenID) => {
    setImagenesListaLoading(true);

    let data = {
      imagenID,
      servicioID: servicioId,
      token,
    };
    dispatch(controller.eliminarImgServicioThunk(data));
  };

  const navigateToSubirThumbnail = (relatedImageId) => {
    logger.debug("navigateToSubirThumbnail");

    const baseUrl = config.api.baseUrl;
    const key = config.api.key;

    const concepto = "servicio";
    const conceptoId = servicioId;

    logger.debug({ concepto });
    logger.debug({ config });
    logger.debug({
      imgRestrictionsByConcepto: config.imgRestrictionsByConcepto[concepto],
    });

    const uploadConfigVariant = "thumbnailUpload";
    const uploadUrl = `${baseUrl}/agregarImagen/${concepto}/${conceptoId}/?userToken=${token}&esTemporal=true&configVariant=${uploadConfigVariant}`;
    const uploadHeaders = {
      "x-access-token": key,
    };

    const cropConfigVariant = "thumbnailCrop";
    const cropUploadUrl = `${baseUrl}/agregarImagen/${concepto}/${conceptoId}/?userToken=${token}&esTemporal=false&configVariant=${cropConfigVariant}`;
    const cropConfig =
      config.imgRestrictionsByConcepto[concepto][cropConfigVariant];

    const nextStepUrl = `/cortarImagenes`;
    const lastStepUrl = `/editServicio/${localId}/${servicioId}`;

    const params = queryString.stringify({
      conceptoId,
      concepto,
      uploadUrl,
      rawUploadHeaders: JSON.stringify(uploadHeaders),
      nextStepUrl,
      pageTitle: "Subida de thumbnail",
      pageSubtitle: "Paso 1 : Subida",
      nextButtonText: "Siguiente",
      cropConfig: JSON.stringify(cropConfig),
      cropUploadUrl,
      saveInConceptUrl: `${baseUrl}/agregarImagenAServicioV3`,
      lastStepUrl,
      relatedImageId,
      ...config.imgRestrictionsByConcepto[concepto][uploadConfigVariant],
    });

    logger.debug("EditServicioHijo.paramsBeforeNavigate");
    logger.debug(params);

    history.push(`/subirImagenes?${params}`);
  };

  return (
    <Content
      title="Editar servicio"
      browserTitle="Editar servicio"
      show={false}
    >
      <Row style={{ marginBottom: 20 }}>
        <Col md="4" mdOffset="4">
          <Box
            title="Editar servicio"
            footer={
              <>
                <Button
                  text="Cancelar"
                  disabled={false}
                  onClick={() => {
                    history.push(
                      `/serviciosHijosList/${match.params.localId}/${servicioPadre}/${match.params.categoriaId}`
                    );
                  }}
                />
                <Button
                  type="primary"
                  text={
                    <Loader
                      loaderColor="#ffffff"
                      isLoading={modelEditServicio.loading}
                    >
                      Guardar
                    </Loader>
                  }
                  pullRight={true}
                  disabled={modelEditServicio.loading}
                  onClick={() => submit()}
                />
              </>
            }
          >
            <ReferenciaObligatorios />

            <SelectInput
              value={estado}
              setValue={setEstado}
              label="Estado"
              options={estadoOptions()}
            />

            {/* <SelectInput
              value={servicioPadre}
              setValue={setServicioPadre}
              label="Servicio padre"
              options={serviciosPadreOptions}
            /> */}

            <Text
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Nombre" obligatorio={true} />}
              value={nombre}
              onChange={(evt) => setNombre(evt.target.value)}
            />

            <Text
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Descripción" obligatorio={true} />}
              value={descripcion}
              onChange={(evt) => setDescripcion(evt.target.value)}
            />

            {match.params.categoriaId !== "60f806a5e3e9af972fe85c7a" ? (
              <>
                <PYG
                  // react-number-format's props
                  value={precio}
                  isNumericString={true}
                  displayType="input"
                  onValueChange={(values) => {
                    const { formattedValue, value } = values;
                    setPrecio(value);
                  }}
                  decimalScale={0}
                  customInput={Text}
                  // adminlte-2-react's Text's props
                  labelPosition="above"
                  size="sm"
                  label={<Etiqueta texto="Precio" obligatorio={true} />}
                />
                <Text
                  inputType="number"
                  labelPosition="above"
                  size="sm"
                  label={
                    <Etiqueta texto="Duración en minutos" obligatorio={true} />
                  }
                  value={duracion}
                  onChange={(evt) => setDuracion(evt.target.value)}
                />

                <Text
                  inputType="number"
                  labelPosition="above"
                  size="sm"
                  label={
                    <Etiqueta texto="Tiempo entre turnos" obligatorio={true} />
                  }
                  value={tiempoEntreTurnos}
                  onChange={(evt) => setTiempoEntreTurnos(evt.target.value)}
                />

                <Text
                  inputType="number"
                  labelPosition="above"
                  size="sm"
                  label={
                    <Etiqueta
                      texto="Máximo de personas por sesión"
                      obligatorio={true}
                    />
                  }
                  value={maxPersonas}
                  onChange={(evt) => setMaxPersonas(evt.target.value)}
                />
              </>
            ) : null}
            {match.params.categoriaId === "60f806a5e3e9af972fe85c7a" ? (
              <>
                <text>
                  <strong>Hora maxima para tomar reserva</strong>
                </text>
                <TimeInput
                  value={horarioTomarReserva}
                  onChange={setHorarioTomarReserva}
                />
                <text>
                  <strong>Hora maxima para realizar reserva</strong>
                </text>
                <TimeInput
                  value={horarioMaximoReservar}
                  onChange={setHorarioMaximoReservar}
                />
              </>
            ) : (
              <Text
                inputType="number"
                labelPosition="above"
                size="sm"
                label={
                  <Etiqueta texto="Minutos depues de la hora actual para mostrar disponibilidades" />
                }
                value={horarioMaximoReservar}
                onChange={(evt) => setHorarioMaximoReservar(evt.target.value)}
              />
            )}

            <label>
              <Etiqueta
                texto={
                  match.params.categoriaId === "60f806a5e3e9af972fe85c7a"
                    ? "Ambientes"
                    : "Profesionales"
                }
                obligatorio={true}
              />
            </label>

            <Multiselect
              hidePlaceholder={true}
              options={profesionalesOptions}
              selectedValues={profesionales}
              onSelect={(selectedList, selectedItem) => {
                setProfesionales([...profesionales, selectedItem]);
              }}
              onRemove={(selectedList, removedItem) => {
                const newProfesionales = profesionales.filter(
                  (item) => item !== removedItem
                );
                setProfesionales(newProfesionales);
              }}
              displayValue="label"
            />

            <br />
            <label>Color para calendario</label>
            <br />

            {colorActual ? (
              <>
                Color actual:{" "}
                <div
                  style={{
                    width: 15,
                    height: 15,
                    backgroundColor: colorActual,
                    display: "inline-block",
                  }}
                ></div>
              </>
            ) : (
              "Sin color definido"
            )}

            <div className="checkbox">
              <label>
                <input
                  type="checkbox"
                  onChange={() => setMostrarColorPicker(!mostrarColorPicker)}
                  checked={mostrarColorPicker}
                />{" "}
                Definir nuevo color
              </label>
            </div>

            {mostrarColorPicker && (
              <HexColorPicker color={color} onChange={setColor} />
            )}
          </Box>
        </Col>
      </Row>
      {/* <Row>
        <Col xs="12" md="6" mdOffset="3">
          <div style={{ display: "inline-block" }}>
            <h4 style={{ display: "inline-block" }}>Imágenes subidas</h4>
          </div>
          <Button
            type="primary"
            text="Subir imágenes"
            pullRight={true}
            onClick={navigateToSubirImagenes}
          />
          <ImagenesLista
            imagenes={imagenes}
            doEliminarImagen={doEliminarImagen}
            loading={imagenesListaLoading}
            navigateToSubirThumbnail={navigateToSubirThumbnail}
          />
        </Col>
      </Row> */}
    </Content>
  );
}

export default EditServicioHijo;
